import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "../../../../assets/css/cms/commentModeration.css";
import { Row, Col, Form } from "react-bootstrap";
import { format } from 'date-fns';
import Select from "react-select";
import { REASON_DROPDOWN, DEGREE_STATUS } from "../../../../constants/cms";
import { getCommentModerationEditAction, putCommentModerationSubmitAction } from "../../../../../store/actions/cms/pollAction";
import "../../../../assets/css/cms/commentModeration.css";
import Alert from "@mui/material/Alert";

export const ManageComments = () => {
  const [publishStatus, setPublishStatus] = useState();
  const navigate = useNavigate();
  const [reason, setReason] = useState();
  const { id } = useParams();
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("success");
  const [reasonError, setReasonError] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [isBlockedByValidation, setIsBlockedByValidation] = useState(false);
  const { commentModerationEditData, commentModerationSubmitData } =
    useSelector((state) => state?.commentModerationReducer);
  const user = useSelector((state) => state?.userData?.user?.data);
  useEffect(() => {
    if(id) {
      dispatch(getCommentModerationEditAction(id));
    }
  }, [id]);

  useEffect(() => {
    if(commentModerationEditData){
      if(commentModerationEditData?.status != null) {
        const status = DEGREE_STATUS.find(opt => opt.id === commentModerationEditData?.status);
        setPublishStatus(status);
      }
      if(commentModerationEditData?.reason != null) {
        const reason = REASON_DROPDOWN.find(opt => opt.id === commentModerationEditData?.reason);
        setReason(reason);
      }
    }
  },[commentModerationEditData]);

  useEffect(() => {
    const reasonRequired = publishStatus?.value === "Unpublished";
    const reasonValid = reasonRequired ? !!reason : true;
  
    if (reasonValid) {
      setIsBlockedByValidation(false);
      setShowAlert(false);
      setAlertMessage("");
    }
  
  }, [publishStatus, reason]);  

  const handleSave = async () => {
    const payload = {
      status: publishStatus?.id !== undefined ? publishStatus.id : null,
      reason: reason?.id !== undefined ? reason.id : null,
      user_id: user?.id,
    };
  
    if (publishStatus?.value === "Unpublished" && !reason) {
      setReasonError("Please select a reason for unpublishing.");
      setIsBlockedByValidation(true);
      return;
    }
  
    setReasonError(""); 

    if (id) {
      const result = await dispatch(putCommentModerationSubmitAction(id, payload));
  
      if (result?.success) {
        setAlertType("success");
        setAlertMessage(result?.data?.message || "Comment updated successfully!");
        setShowAlert(true);
        setIsBlockedByValidation(false);

        setTimeout(() => {
          navigate("/cms/polls/comment-moderation");
        }, 2000);

      } else {
        setAlertType("error");
        setAlertMessage(result?.error || "Failed to save changes.");
        setIsBlockedByValidation(true);
        setShowAlert(true);
      }
    }
  };  

  const handleCancel = () => {
    navigate("/cms/polls/comment-moderation");
  };  
  

const bothFieldsCleared = !publishStatus && !reason;

const canSubmit = !isBlockedByValidation && !bothFieldsCleared;


  return (
    <>
      {showAlert && (
          <div className="notification_popup">
            <Alert severity={alertType}>{alertMessage}</Alert>
          </div>
        )}
      <div style={{ backgroundColor: '##edeef2', minHeight: '100vh' }}>
        <h4>Edit Comments</h4>

        {/* <div className="custom_breadcrumb">
          <ul className="custom_breadcrumb_ul">
            <li className="custom_breadcrumb_list">
              <a href="/cms" className="sub_nan_anchor">
                Home
              </a>
            </li>
            <li className="custom_breadcrumb_list">
              <span>
                <FiChevronRight />
              </span>
            </li>
            <li className="custom_breadcrumb_list">
              <a href="/cms/polls/comment-moderation" className="sub_nan_anchor">
                Manage Comment Moderation
              </a>
            </li>
            <li className="custom_breadcrumb_list">
              <span>
                <FiChevronRight />
              </span>
            </li>
            <li className="custom_breadcrumb_list custom_breadcrumb_list_active">
              {id ? "Edit Comments" : ""}
            </li>
          </ul>
        </div> */}

        <div className="comment_field_container">
          <h3 className="comment_heading">Comment</h3>
          <p className="comment_desc">
              {commentModerationEditData?.comment || "Comment not Available"}
          </p>
        </div>

        <Row className="comment_moderation">
          <Col md={6}>
              <Form.Group className="mb-3">
              <Select
                  placeholder= "Publishing Status"
                  isClearable
                  options={DEGREE_STATUS || ""}
                  getOptionLabel={(opt) => opt?.value}
                  getOptionValue={(opt) => opt?.id}
                  onChange={(obj) => {
                    setPublishStatus(obj) 
                    if (!obj) {
                      setReason(null);
                      setShowAlert(false);
                      setIsBlockedByValidation(false);
                      setAlertMessage("");
                      setReasonError("");
                      return;
                    }                
                    if (obj?.value === "Published") {
                      setReason(null); 
                      setShowAlert(false); 
                      setIsBlockedByValidation(false);
                      setAlertMessage("");
                      setReasonError("");
                    }
                    if(obj?.value === "Unpublished"){
                      setIsBlockedByValidation(true);
                    }
                  }}
                  value={publishStatus}
              />
              </Form.Group>
          </Col>
          <Col md={6}>
              <Form.Group className="mb-3">
              <Select
                  placeholder= "Reason if Unpublish"
                  isClearable
                  isDisabled={!publishStatus || publishStatus?.value === "Published"}
                  options={REASON_DROPDOWN || ""}
                  getOptionLabel={(opt) => opt?.value}
                  getOptionValue={(opt) => opt?.id}
                  value={reason}
                  onChange={(obj) => {
                    setReason(obj)
                    setReasonError("");
                  }}
                  required
              />
              {reasonError && (
                <div style={{ color: "red", fontSize: "0.85rem", marginTop: "4px" }}>
                  {reasonError}
                </div>
              )}
              </Form.Group>
          </Col>
        </Row>

        <div className="comment_details">
        <h3>User Details</h3>
        {commentModerationEditData?.user &&
          Object.values(commentModerationEditData.user).some(val => val !== null && val !== "" && val !== undefined) ? (
          <>
            <Row className="comment_moderation_details">
              <Col md={4}>
                <h4>User Name: {commentModerationEditData?.user?.name || "Username not Available"}</h4>
              </Col>
              <Col md={4}>
                <h4>Interested In: {commentModerationEditData?.user?.interested_in || "Interest not Available"}</h4>
              </Col>
              <Col md={4}>
                <h4>Location: {commentModerationEditData?.user?.location || "Location not Available"}</h4>
              </Col>
            </Row>

            <Row className="comment_moderation_details">
              <Col md={4}>
                <h4>Email Id: {commentModerationEditData?.user?.email || "Emailid not Available"}</h4>
              </Col>
              <Col md={4}>
                <h4>Phone Number: {commentModerationEditData?.user?.phone_number || "Phone no. not Available"}</h4>
              </Col>
              <Col md={4}>
                <h4>
                  Joined On: {
                    commentModerationEditData?.user?.joined_on &&
                    !isNaN(new Date(commentModerationEditData.user.joined_on))
                      ? format(new Date(commentModerationEditData.user.joined_on), 'dd MMM yyyy')
                      : "joined date not Available"
                  }
                </h4>
              </Col>
            </Row>
          </>
        ): 
        <p className="fallback_details">User information not available</p>
        }
        </div>

        <div className="button_container">
            <div style={{marginTop: '30px'}}>
            <button
              className={canSubmit ? "submit_button" : "disabled_save_button"}
              type="button"
              onClick={handleSave}
              disabled={!canSubmit}
            >
              Submit
            </button>
          </div>

          <div style={{marginTop: '30px', marginLeft: '10px'}}>
            <button
              className="submit_button"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
